<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <div class="card">
    <div class="card-header d-flex align-items-center bg-primary font-weight-bold text-white">
      Kantor Akuntan Publik
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <!-- <div class="card-header bg-white text-muted h4">Tambah</div> -->
    <div class="card-body">
      <div class="card border-0 shadow p-2">
        <div class="card-body">
          <form @submit.prevent="postData">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="no_izin" class="font-weight-bold">Nomor Izin KAP</label>
                <input
                  type="text"
                  class="form-control"
                  id="no_izin"
                  placeholder="Masukkan Nomor Izin KAP"
                  v-model="formData.no_izin"
                  @input="setNoIzin($event.target.value)"
                  :class="{
                    'border-danger': $v.formData.no_izin.$error                
                  }"
                />
              </div>
              <div class="form-group col-md-12">
                <label for="nama_kap" class="font-weight-bold">Nama KAP</label>
                <input
                  type="text"
                  class="form-control"
                  id="nama_kap"
                  placeholder="Masukkan Nama KAP"
                  v-model="formData.nama_kap"
                  @input="setNamaKap($event.target.value)"
                  :class="{
                    'border-danger': $v.formData.nama_kap.$error                
                  }"
                />
              </div>
              <div class="form-group col-md-12">
                <label for="nama_kap" class="font-weight-bold">Nomor FAX</label>
                <input
                  type="text"
                  class="form-control"
                  id="nomor_fax"
                  placeholder="Masukkan Nomor FAX"
                  v-model="formData.nomor_fax"
                  :class="{
                    'border-danger': $v.formData.nomor_fax.$error                
                  }"
                />
              </div>
              <div class="form-group col-md-12">
                <label for="no_telephone" class="font-weight-bold">No. Telepon</label>
                <input
                  type="text"
                  class="form-control"
                  id="no_telephone"
                  placeholder="Masukkan No. Telepon"
                  :max="max"
                  v-model="formData.no_telephone"
                  @input="setNoTelp($event.target.value)"
                  :class="{
                    'border-danger': $v.formData.no_telephone.$error                
                  }"
                />
              </div>
            </div>
            <div class="form-row">              
              <div class="form-group col-md-12">
                <label for="tanggal_izin" class="font-weight-bold">Tanggal Izin KAP</label>
                <input
                  type="date"
                  class="form-control"
                  id="tanggal_izin"
                  placeholder="Pilih Tanggal Izin Berlaku KAP"
                  v-model="formData.tanggal_izin_kap"
                  
                  :class="{
                    'border-danger': $v.formData.tanggal_izin_kap.$error                
                  }"
                />
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="kapaOaaa" class="font-weight-bold">KAPA/OAA</label>
                <input
                  type="text"
                  class="form-control"
                  id="kapaOaa"
                  placeholder="Masukkan Nama KAPA/OAA"
                  v-model="formData.kapa"
                  @input="setKapaOaa($event.target.value)"
                  :class="{
                    'border-danger': $v.formData.kapa.$error                
                  }"
                />
              </div>
              <div class="form-group col-md-12">
                <label for="tanggal_kapa" class="font-weight-bold">Tanggal KAPA</label>
                <input
                  type="date"
                  class="form-control"
                  id="tanggal_kapa"
                  placeholder="Pilih Tanggal Cabut Izin"
                  v-model="formData.tanggal_kapa"
                   
                  
                />
              </div>
              
              <div class="form-group col-md-12">
                <label for="no_cabut_izin" class="font-weight-bold">Nomor Cabut Izin</label>
                <input
                  type="text"
                  class="form-control"
                  id="no_cabut_izin"
                  placeholder="Masukkan Nomor Cabut Izin"
                  v-model="formData.no_cabut_izin"
                  @input="setNoCabutIzin($event.target.value)"
                  
                />
              </div>
            </div>
            <div class="form-row">              
              <div class="form-group col-md-12">
                <label for="tglcabut" class="font-weight-bold">Tanggal Cabut Izin</label>
                <input
                  type="date"
                  class="form-control"
                  id="tglcabut"
                  placeholder="Pilih Tanggal Cabut Izin"
                  v-model="formData.tanggal_cabut_izin"
                   
                />
              </div>
              <div class="form-group col-md-12">
                <label for="alamat" class="font-weight-bold">Alamat</label>
                <textarea 
                  id="alamat"
                  cols="30" 
                  class="form-control"
                  placeholder="Masukkan Alamat"
                  v-model="formData.alamat"
                  rows="5"
                  @input="setAlamat($event.target.value)"
                  :class="{
                    'border-danger': $v.formData.alamat.$error                
                  }"
                ></textarea>              
              </div>              
              <div class="form-group col-md-12" :validator="$v.formData.kotakab">
                <label for="kotaKab" class="font-weight-bold">Kota/Kab</label>
                <multiselect
                  label="name"
                  placeholder="Pilih Kota/Kab"
                  id="kotaKab"
                  @select="updateSelect"                  
                  v-model="datakotakab"
                  :options="KotaKab"     
                  :class="{
                    'has-error': $v.datakotakab.$error                
                  }"                            
                ></multiselect>
                <!-- <span v-if="$v.formData.kotakab.$error" class="text-danger">
                  *Mohon isi Kota / Kabupaten
                </span> -->
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="kap_terdaftar_ojk" class="font-weight-bold">KAP Terdaftar di OJK</label>                
                  <input
                  id="kap_terdaftar_ojk"
                  type="text"
                  class="form-control"
                  v-model="formData.kap_terdaftar_di_ojk"
                  placeholder="Masukkan nomor STTD yang terdaftar"
                  @input="setKapTerdaftarOjk($event.target.value)"
                  :class="{
                    'border-danger': $v.formData.kap_terdaftar_ojk.$error                
                  }"
                />
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="form-group col-md-12">
                <label for="kap_terdaftar_di_bpk" class="font-weight-bold">KAP Terdaftar di BPK</label>
                <input
                  id="kap_terdaftar_di_bpk"
                  type="text"
                  class="form-control"
                  v-model="formData.kap_terdaftar_di_bpk"
                  placeholder="Masukkan nomor STTD yang terdaftar"
                  @input="setKapTerdaftarBpk($event.target.value)"
                  :class="{
                    'border-danger': $v.formData.kap_terdaftar_di_bpk.$error                
                  }"
                />
              </div>
            </div>
            <div class="form-row mt-2">
              <div class="form-group col-md-12">
                <label for="no_sk_cabut_izin" class="font-weight-bold">Nomor SK Cabut Izin</label>
                <input
                  id="no_sk_cabut_izin"
                  type="text"
                  v-model="formData.nomor_sk_cabut_izin"
                  class="form-control"
                  placeholder="Masukkan nomor SK Cabut Izin"  
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="row">
        <CCol sm="12">
          <label for class="font-weight-bold">Status</label>
          <br />
          <div class="d-flex align-items-center">
            <div class="custom-control custom-radio custom-control-inline">
              <input
                required
                type="radio"
                class="custom-control-input"
                name="customRadio"
                id="aktif"
                value="1"
                v-model="formData.status"
              />
              <label class="custom-control-label" for="aktif">Aktif</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
              <input
                required
                type="radio"
                class="custom-control-input"
                name="customRadio"
                id="tidak_aktif"
                value="0"
                v-model="formData.status"
              />
              <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
            </div>
          </div>
          <span v-if="$v.formData.status.$error" class="text-danger">
            *Mohon pilih status
          </span>
        </CCol>
      </div>
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">
      <Button
        @click="postData"
        class="btn btn-md btn-success px-4 py-2"
        type="submit"
        color="success"
      >Simpan</Button>
    </div>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';
import KapService from "@/services/keanggotaan/kap.service";
import KotaKabupatenService from "@/services/datamaster/kota-kabupaten.service";

export default {
  name: "Kap",
  data() {
    return {
      sports: '',
      sports_array: ['Football','Tennis','Swimming','Body Building'],      
      datakotakab: [],
      KotaKab: [],

      actionPost: "",
      max: '',
      formData: {
        kap_terdaftar_di_bpk: "",
        kap_terdaftar_ojk : "",
        nomor_sk_cabut_izin : "",
        nama_kap: "",
        nomor_fax: "",
        no_izin: "",
        tanggal_kapa: new Date().toISOString().slice(0, 10),
        no_cabut_izin: "",
        alamat: "",
        tanggal_izin_kap: new Date().toISOString().slice(0, 10),
        kapa: "",
        no_telephone: "",
        tanggal_cabut_izin: "",
        status_bank_konvensional: "",
        status_bank_syariah: "",
        status_inkb: "",
        status_pasar_modal: "",
        status_terdaftar_di_bpk: "",
        status_terdaftar_di_ojk: "",
        kota_kab: "",
        status: "",
        id_kap: "",

        name: "",
        KotaKab: "",
        idKotaKab: "",

        today: moment().format("YYYY-MM-DD"),
      },
        today: moment().format("YYYY-MM-DD"),
    };
  },

  validations: {
    formData: {      
      alamat: { required },      
      kap_terdaftar_di_bpk: { required },      
      kap_terdaftar_ojk: { required },
      kapa: { required },               
      nama_kap: { required },      
      
      nomor_fax: { required },      
      no_izin: { required },
      no_telephone: { required },
      status: { required },      
      tanggal_izin_kap: { required },
    },
    datakotakab: { required }
  },

  mounted() {
    this.getKotaKab();
    this.today = moment().format("YYYY-MM-DD");
  },  

  methods: {
    setNoIzin(value){
      this.formData.no_izin = value;
      this.$v.formData.no_izin.$touch();
      if(!this.$v.formData.no_izin.$error) {
        document.getElementById('no_izin').classList.add('border-success');
      }
    },
    setNamaKap(value){
      this.formData.nama_kap = value;
      this.$v.formData.nama_kap.$touch();
      if(!this.$v.formData.nama_kap.$error) {
        document.getElementById('nama_kap').classList.add('border-success');
      }
    },
    setNoTelp(value) {
      this.formData.no_telephone = value;
      this.$v.formData.no_telephone.$touch();
      if(!this.$v.formData.no_telephone.$error) {
        document.getElementById('no_telephone').classList.add('border-success');
      }
      if (String(value).length <= 14) {
        this.max = value
      }
      this.$forceUpdate()
    },
    setTanggalIzin(value) {
      this.formData.tanggal_izin_kap = value;
      this.$v.formData.tanggal_izin_kap.$touch();
      if(!this.$v.formData.tanggal_izin_kap.$error) {
        document.getElementById('tanggal_izin').classList.add('border-success');
      }
    },
    setKapaOaa(value) {
      this.formData.kapa = value;
      this.$v.formData.kapa.$touch();
      if(!this.$v.formData.kapa.$error) {
        document.getElementById('kapaOaa').classList.add('border-success');
      }
    },
    setNoCabutIzin(value) {
      this.formData.no_cabut_izin = value;
      this.$v.formData.no_cabut_izin.$touch();
      if(!this.$v.formData.no_cabut_izin.$error) {
        document.getElementById('no_cabut_izin').classList.add('border-success');
      }
    },
    setTanggalCabutIzin(value) {
      this.formData.tanggal_cabut_izin = value;
      this.$v.formData.tanggal_cabut_izin.$touch();
      if(!this.$v.formData.tanggal_cabut_izin.$error) {
        document.getElementById('tglcabut').classList.add('border-success');
      }
    },
    setAlamat(value) {
      this.formData.alamat = value;
      this.$v.formData.alamat.$touch();
      if(!this.$v.formData.alamat.$error) {
        document.getElementById('alamat').classList.add('border-success');
      }
    },
    setKapTerdaftarOjk(value) {
      this.formData.kap_terdaftar_ojk = value;
      this.$v.formData.kap_terdaftar_ojk.$touch();
      if(!this.$v.formData.kap_terdaftar_ojk.$error) {
        document.getElementById('kap_terdaftar_ojk').classList.add('border-success');
      }
    },
    setKapTerdaftarBpk(value) {
      this.formData.kap_terdaftar_di_bpk = value;
      this.$v.formData.kap_terdaftar_di_bpk.$touch();
      if(!this.$v.formData.kap_terdaftar_di_bpk.$error) {
        document.getElementById('kap_terdaftar_di_bpk').classList.add('border-success');
      }
    },

    alertError() {
      this.$swal.fire({
        title: "Peringatan!",
        text: "Data Gagal Disimpan",
        icon: "errorr",
        showCancelButton: true
      });
    },

    alertSuccess() {
      var vm = this;

      const Toast = vm.$swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        onOpen: toast => {
          toast.addEventListener("mouseenter", vm.$swal.stopTimer);
          toast.addEventListener("mouseleave", vm.$swal.resumeTimer);
        }
      });
      Toast.fire({
        icon: "success",
        title: "Data Berhasil Disimpan"
      });
    },

    getKotaKab() {
      var vm = this;
      KotaKabupatenService.getAll()

        .then(response => {
          // comment console console.log(response.data.data.content);
          vm.KotaKab = response.data.data.content;
        })

        .catch(error => {
          // comment console console.log(error);
        });
    },

    updateSelect(event) {
      var vm = this;      
      this.$v.datakotakab.$touch();    
      this.formData.kotakab = event.id_kota_kab;  
    },

    postData() {     
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {          
        this.insertData(this.formData);
        this.$router.push({ path: "/keanggotaan/kap" });
        this.formData.KotaKab = [{ name: "" }];
      }                 
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      // comment console console.log(formData);
      // comment console console.log("post");

      var vm = this;

      KapService.postKap(formData)
        .then(response => {
          loader.hide();

          vm.myModal = false;
          vm.alertSuccess();

          vm.$router.push({ path: "/keanggotaan/kap" });
        })
        .catch(error => {
          loader.hide();

          // comment console console.log(error);
        });
    },

    clearValidations() {
      this.$v.$reset();

      // Clear border-success class
      document.getElementById('no_izin').classList.remove('border-success');      
      document.getElementById('nama_kap').classList.remove('border-success');
      document.getElementById('no_telephone').classList.remove('border-success');
      // document.getElementById('tanggal_izin').classList.remove('border-success');
      document.getElementById('kapaOaa').classList.remove('border-success');
      document.getElementById('no_cabut_izin').classList.remove('border-success');
      // document.getElementById('tglcabut').classList.remove('border-success');
      document.getElementById('alamat').classList.remove('border-success');
      document.getElementById('kap_terdaftar_ojk').classList.remove('border-success');
      document.getElementById('kap_terdaftar_di_bpk').classList.remove('border-success');
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>